import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { TableMeta } from "../../models/table-meta.interface";
import { TosTableTdComponent } from "../tos-table/tos-table-td/tos-table-td.component";
import { NoDataComponent } from "../no-data/no-data.component";
import { User } from "../../models/user.interface";
import { FormsModule } from "@angular/forms";
import { CommonUtils } from "../../utils/common-utils";

@Component({
  selector: "app-static-table",
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    SvgIconComponent,
    NgClass,
    NoDataComponent,
    NgStyle,
    FormsModule,
    TosTableTdComponent
  ],
  templateUrl: "./static-table.component.html",
  styleUrl: "./static-table.component.scss"
})
export class StaticTableComponent {
  private allTableRecordsSelected: boolean = false;

  @Input() data: any[] = [];
  @Input() tableMeta!: TableMeta;
  @Input() readOnlyMode: boolean = false;
  @Input() deleteAllowed: boolean = true;
  @Input() editAllowed: boolean = false;
  @Input() showCheckBox: boolean = true;
  @Input() selectedItems: any[] = [];
  @Input() showBorders: boolean = false;
  @Input() showSerialNumber: boolean = true
  @Input() noDataFoundMsg: string = "No Data Found.";
  @Input() idKey: string = "id";
  @Input() noDataIconPath: string = "assets/images/no-data-new.svg";

  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() dataDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditRecord: EventEmitter<any> = new EventEmitter<{index: number, record: any}>();
  @Output() selectedItemsChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowActionTriggered = new EventEmitter<any>();

  totalColspan = 0;

  @ViewChild('headerRow', { static: false }) headerRow!: ElementRef<HTMLTableRowElement>;


  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnChanges(change: SimpleChanges){

  }

  ngAfterViewInit(): void {
    this.totalColspan = this.headerRow?.nativeElement?.children?.length || 0;
    this.cdr.detectChanges();
  }

  removeElement(i: number,result: any) {
    this.data = this.data.filter((d: any) => d[this.idKey] !== result[this.idKey])
    this.dataChange.emit(this.data)
    this.dataDeleted.emit(result);
  }

  editRecord(index: number, record: any) {
    this.onEditRecord.emit({index, record});
  }

  isAllRecordsOfCurrentPageSelected() {
    return (
      this.allTableRecordsSelected ||
      (this.data?.length > 0 &&
        this.data?.every((item: User) =>
          this.isSelected(item)
        ))
    );
  }

  toggleAllRecordsOfCurrentPageSelections(isChecked: any) {
    if (isChecked) {
      this.data?.forEach((item) => {
        if (!this.isSelected(item)) {
          this.selectedItems.push(item);
        }
      });
    } else {
      this.data?.forEach((item) => {
        this.selectedItems = this.selectedItems.filter((i) => i[this.idKey] !== item[this.idKey]);
      });
    }

    this.selectedItemsChange.emit(this.selectedItems);
  }

  toggleSelection(record: any) {
    if (!this.isSelected(record)) {
      this.selectedItems.push(record);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i[this.idKey] !== record[this.idKey]);
    }
    this.selectedItemsChange.emit(this.selectedItems);
  }

  isSelected(item: any) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x[this.idKey] === item[this.idKey]);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  handleInlineAction(event: { actionName: string; record: any }, index: number) {
    this.rowActionTriggered.emit({actionName: event.actionName, record: event.record, index});
  }

  hasVisibleActions(): boolean {
    if (!this.tableMeta?.actions?.length) return false;
  
    return this.tableMeta.actions.some(column => {
      const isWriteOperation = column?.styleConfig?.actionConfig?.writeOperation ?? false;
      return !(this.readOnlyMode && isWriteOperation);
    });
  }

  protected readonly CommonUtils = CommonUtils;
}
